export default __webpack_public_path__ + "434554c25d0262d9ae16c700febfa462.png";